import { useTheme } from '@mui/material';

import { CreateLeadStepper } from '@modules/_shared/components/create-lead/CreateLeadStepper';
import { Drawer } from '@modules/_shared/components/drawer/Drawer';
import type { RaAddressType } from '@modules/_shared/components/form/RaAddressInput';
import { useLocale } from '@shared/hooks/locale';

type CreateLeadDrawerProps = {
  onClose: () => void;
  onCreate: (leadId: string) => void;
  userId?: string;
  // Prefills the address step (e.g. create-lead from a map parcel).
  initialAddress?: RaAddressType;
};

export const CreateLeadDrawer = ({
  onClose,
  onCreate,
  userId,
  initialAddress,
}: CreateLeadDrawerProps) => {
  const { t } = useLocale();
  const { breakpoints } = useTheme();

  return (
    <Drawer
      onClose={onClose}
      title={t('Create seller lead')}
      maxWidth={breakpoints.values.md}
      sx={{ zIndex: 1300 }}
    >
      <CreateLeadStepper
        onLeadCreated={onCreate}
        userId={userId}
        initialAddress={initialAddress}
      />
    </Drawer>
  );
};

CreateLeadDrawer.displayName = 'CreateLeadDrawer';
